function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5 14H14.5V13H12.5V16H28.5V13H26.5V14H24.5V13H16.5V14ZM28.5 18H12.5V28H28.5V18ZM24.5 11H16.5V10H14.5V11H12.5C11.3954 11 10.5 11.8954 10.5 13V28C10.5 29.1046 11.3954 30 12.5 30H28.5C29.6046 30 30.5 29.1046 30.5 28V13C30.5 11.8954 29.6046 11 28.5 11H26.5V10H24.5V11ZM15.5 22V20H17.5V22H15.5ZM19.5 22H21.5V20H19.5V22ZM23.5 22V20H25.5V22H23.5ZM15.5 24V26H17.5V24H15.5ZM21.5 26H19.5V24H21.5V26Z",
  fill: "url(#paint0_linear_28_2701)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1,
  width: 38,
  height: 38,
  rx: 19,
  stroke: "url(#paint1_linear_28_2701)",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28_2701",
  x1: -0.999999,
  y1: 9.58152,
  x2: -0.999999,
  y2: 26.4952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_28_2701",
  x1: -22.5,
  y1: -0.836964,
  x2: -22.5,
  y2: 32.9903,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})));

function SvgScheduleAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgScheduleAssignment);
export default __webpack_public_path__ + "static/media/schedule-assignment.0f2c63ad.svg";
export { ForwardRef as ReactComponent };